import React from 'react';

const ErrorDisplay = ({ error }) => {
  if (!error) return null;

  return (
    <div className="bg-red-50 rounded-2xl p-6 border-l-4 border-red-500 shadow-smdd-card">
      <div className="flex items-start">
        <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center mr-3 mt-0.5">
          <svg
            className="w-3 h-3 text-white"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div>
          <h3 className="text-base font-baijamjuree font-semibold text-red-800">
            Submission Error
          </h3>
          <p className="text-sm text-red-700 mt-1 font-baijamjuree">{error}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
